// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"d3e57b02","271":"55964863","329":"c6d7e4bb","416":"ea681a85","428":"63029e30","456":"a20f6480","496":"958f7d30","898":"67dd5f54","936":"b7289f1b","965":"e75505fe","970":"75155a30"}[chunkId] + ".chunk.js";
};